package com.appcreator.blueprint.core.properties

import kotlinx.serialization.Serializable

@Serializable
data class DataValueSet(
    val values: Map<String, String>,
)
